import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';

export enum OutputType {
  CONDITION = 'CONDITION',
  SIGNAL = 'SIGNAL',
}

const packageName = SeeqNames.MlService.SelfOrganizingMap.Connection.UdfPackage;
const udfName = SeeqNames.MlService.SelfOrganizingMap.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;
